import React from 'react'
import { DoughnutChartProps } from './DoughnutChart.types'
import { statsColorPallette } from 'store'
import { EChart } from '../EChart'
import {
  CHART_COLORS,
  CHART_FONT_FAMILY,
  formatCenterLabel,
  toChartNumber
} from '../chartTheme'
import styles from './DoughnutChart.module.scss'

const DoughnutComponent = (props: DoughnutChartProps) => {
  const palette = statsColorPallette.map(({ fill }) => fill)
  const data = (props.data || []).map((item, index) => ({
    name: item.label,
    value: toChartNumber(item.value),
    itemStyle: {
      color: palette[index % palette.length]
    }
  }))
  const centerLabel = formatCenterLabel(props.centerLabel)
  const labelLines = centerLabel.split('\n').map((line) => line.trim()).filter(Boolean)
  const titleText = labelLines[0] || ''
  const valueText = labelLines.slice(1).join('\n')

  const option = {
    backgroundColor: 'transparent',
    tooltip: { show: false },
    legend: { show: false },
    series: [
      {
        type: 'pie',
        radius: ['60%', '84%'],
        center: ['50%', '50%'],
        silent: true,
        avoidLabelOverlap: true,
        label: { show: false },
        labelLine: { show: false },
        data
      }
    ],
    graphic: [
      {
        type: 'text',
        left: 'center',
        top: valueText ? '43%' : 'middle',
        z: 10,
        style: {
          text: titleText,
          fill: CHART_COLORS.secondaryContent,
          fontSize: 10,
          fontFamily: CHART_FONT_FAMILY,
          fontWeight: 400,
          textAlign: 'center',
          textVerticalAlign: 'middle'
        }
      },
      valueText
        ? {
          type: 'text',
          left: 'center',
          top: '54%',
          z: 10,
          style: {
            text: valueText,
            fill: CHART_COLORS.primaryContent,
            fontSize: 16,
            fontFamily: CHART_FONT_FAMILY,
            fontWeight: 700,
            textAlign: 'center',
            textVerticalAlign: 'middle'
          }
        }
        : null
    ].filter(Boolean)
  }

  return (
    <div className={styles.container}>
      <EChart
        className={styles.chart}
        option={option}
        width={220}
        height={220}
      />
    </div>
  )
}

const Doughnut = DoughnutComponent
export { Doughnut }
